import { AppConfig } from 'src/types';

type Window = {
  __TS_CONFIG__?: AppConfig;
};

type Globals = {
  window: Window;
};

export default Object.defineProperty({}, 'window', {
  get: () => (typeof window === 'undefined' ? {} : window),
}) as Globals;
